module.exports = __webpack_public_path__ + "static/media/2.1b72b098.png";